import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC, ReactElement } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { Decoration } from './Decoration'
import { MAIN_TITLE_STYLE, NOTES_BOLD_STYLE } from './styles'
import { Paragraph } from './Text'
import logo from '../assets/logo.svg'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 48,
    marginBottom: 32,
    minHeight: 98,
    position: 'relative',
  },
  logo: {
    width: 43,
    marginBottom: 30,
  },
  decoration: {
    position: 'absolute',
    top: 7,
    right: -60,
  },
  title: {
    ...MAIN_TITLE_STYLE,
    marginTop: 'auto',
    marginBottom: 0,
    maxWidth: 'calc(100% - 80px)',
  },
  subtitle: {
    ...NOTES_BOLD_STYLE,
    color: '#90734F',
    maxWidth: 'calc(100% - 80px)',
    marginTop: 16,
  },
})

interface Props {
  title: string | ReactElement
  subtitle?: string
  className?: string
}

export const OnboardingHeader: FC<Props> = flowMax(
  addDisplayName('OnboardingHeader'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ title, subtitle, classes, className }) => (
    <div className={cx(classes.container, className)}>
      <img src={logo} alt="" className={classes.logo} />
      <Decoration decoration="cactus" className={classes.decoration} />
      <h1 className={classes.title}>{title}</h1>
      {!!subtitle && (
        <Paragraph type="notes2" className={classes.subtitle}>
          {subtitle}
        </Paragraph>
      )}
    </div>
  )
)
